module.exports = __webpack_public_path__ + "img/axa-sigorta.862f254a.jpg";